/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Apply For Benefits action types.
 *
 */
import { ReduxUtils } from '@spm/core';
import Constants from '../App/constants';
import RESOURCE_NAMES from '../App/resources';
var FEATURE_NAME = 'ApplyForBenefits';

/**
 * Sets the intake application type for benefit.
 */
var APPLY_FOR_BENEFITS_SET_INTAKE_APPLICATION_TYPE = ReduxUtils.generateActionType(Constants.LIBRARY_ROOT, FEATURE_NAME, 'APPLY_FOR_BENEFITS_SET_INTAKE_APPLICATION_TYPE');

/**
 * Sets the previous page when applying for benefits.
 */
var APPLY_FOR_BENEFITS_SET_PREVIOUS_PAGES = ReduxUtils.generateActionType(Constants.LIBRARY_ROOT, FEATURE_NAME, 'APPLY_FOR_BENEFITS_SET_PREVIOUS_PAGES');

/**
 * Sets the user's applications selection when applying for benefits.
 */
var APPLY_FOR_BENEFITS_SET_APPLICATION_SELECTION = ReduxUtils.generateActionType(Constants.LIBRARY_ROOT, FEATURE_NAME, 'APPLY_FOR_BENEFITS_SET_APPLICATION_SELECTION');

/**
 * Sets temporary user when applying for benefits as generated.
 */
var APPLY_FOR_BENEFITS_SET_TEMPORARY_USER_LOGGING_IN = ReduxUtils.generateActionType(Constants.LIBRARY_ROOT, FEATURE_NAME, 'APPLY_FOR_BENEFITS_SET_TEMPORARY_USER_LOGGING_IN');
var ONLINE_SCREENING_SET_SCREENING_TYPE_SELECTION = ReduxUtils.generateFetchActionTypes(Constants.LIBRARY_ROOT, RESOURCE_NAMES.screeningForm);

/**
 *Generate the action types for apply for benefits.
 *
 * @param {string} LIBRARY_ROOT The folder name
 * @param {string} resource The online categories resource
 *
 * @returns {*} The apply for benefits action types
 */
var APPLY_FOR_BENEFITS_FETCH_ONLINE_CATEGORIES_ACTION_TYPES = ReduxUtils.generateActionTypes(Constants.LIBRARY_ROOT, RESOURCE_NAMES.onlineCategories);
export { APPLY_FOR_BENEFITS_SET_INTAKE_APPLICATION_TYPE, APPLY_FOR_BENEFITS_SET_PREVIOUS_PAGES, APPLY_FOR_BENEFITS_SET_APPLICATION_SELECTION, APPLY_FOR_BENEFITS_SET_TEMPORARY_USER_LOGGING_IN, APPLY_FOR_BENEFITS_FETCH_ONLINE_CATEGORIES_ACTION_TYPES, ONLINE_SCREENING_SET_SCREENING_TYPE_SELECTION };